<template>
    <div id="fahrzeug">
        <h2>{{ fahrzeug.name }}</h2>
        <div class="field right-aligned">
            <button @click="fahrzeugBearbeiten()" class="fa">&#xf044;</button>
            <button @click="fahrzeugLoeschen()" class="buttonDelete fa">&#xf1f8;</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: "Fahrzeug",
    components: {},
    props: {
        fahrzeug: Object,
    },
    data() {
        return {};
    },
    methods: {
        async fahrzeugLoeschen() {
            await Swal.fire({
                title: "Fahrzeug dauerhaft löschen?",
                showDenyButton: true,
                //showCancelButton: true,
                confirmButtonText: "Löschen",
                denyButtonText: `Nicht Löschen`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.deleteFahrzeug();
                    //Swal.fire("Hydrant erfolgreich gelöscht", "", "success");
                } else if (result.isDenied) {
                    //Swal.fire("Changes are not saved", "", "info");
                }
            });
        },
        async deleteFahrzeug() {
            try {
                await axios.delete(
                    'https://feuerwehr-server.org:5000/deleteFahrzeug',
                    { params: { feuerwehrID: this.$props.fahrzeug.feuerwehrID ,fahrzeugID: this.$props.fahrzeug.fahrzeugID } }
                );
                this.deleteFile(this.$props.fahrzeug.imagePath);
                Swal.fire("Fahrzeug wurde erfolgreich gelöscht", "", "success");
                this.$emit('updateFahrzeugTable');
            } catch (err) {
                console.log(err);
                Swal.fire(
                    'Fehler beim Löschen!',
                    '',
                    'error'
                );
            };
        },
        async deleteFile(filePath) {
            try {
                const response = await fetch('https://feuerwehr-server.org:5000/delete-image', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ filePath: filePath }) // Pfad der Datei senden
                });

                const result = await response.json();
                if (result.success) {
                    console.log('Datei erfolgreich gelöscht:', result.message);
                } else {
                    console.error('Fehler beim Löschen der Datei:', result.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
    fahrzeugBearbeiten(){
            this.$emit('fahrzeugBearbeiten', this.$props.fahrzeug);
        }
    },
    created() {
        
    },
};
</script>

<style lang="scss">
#fahrzeug {
    font-size: x-large;
    display: flex;
    justify-content: space-between;
    margin-left: 10%;
    margin-right: 10%;
    background-color: white;
    border: solid black 0.2rem;
    margin-bottom: -0.1rem;
    padding: 0.3rem;
    padding-left: 3rem;

    @media (max-width: 768px) {
        padding-left: 0rem;
        flex-direction: column;
        align-items: center;

        h2{
            margin-bottom: 0px;
        }

        .field {
            width: auto !important;
        }
    }
}
</style>